import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "form-section" }
const _hoisted_2 = { class: "compact-field" }
const _hoisted_3 = { class: "compact-field" }
const _hoisted_4 = {
  key: 0,
  class: "field-error"
}
const _hoisted_5 = { class: "compact-field" }
const _hoisted_6 = { class: "birth-number-input-group" }
const _hoisted_7 = { class: "field-hint" }
const _hoisted_8 = { class: "compact-field" }
const _hoisted_9 = { class: "form-section" }
const _hoisted_10 = { class: "compact-field" }
const _hoisted_11 = { class: "compact-field" }
const _hoisted_12 = { class: "form-section" }
const _hoisted_13 = { class: "compact-field" }
const _hoisted_14 = { class: "address-input-group" }
const _hoisted_15 = { class: "compact-field" }
const _hoisted_16 = { class: "form-section" }
const _hoisted_17 = { class: "compact-field" }
const _hoisted_18 = { class: "compact-field" }
const _hoisted_19 = {
  key: 0,
  class: "loading-overlay"
}

import { ref, computed, watch, nextTick } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';

interface Props {
  modelValue: boolean;
  employee?: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeFormModal',
  props: {
    modelValue: { type: Boolean },
    employee: {}
  },
  emits: ["update:modelValue", "saved"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();
const user = computed(() => store.state.user);

const props = __props;

const emit = __emit;

// 상태
const formValid = ref(false);
const employeeForm = ref();
const isSaving = ref(false);
const addressDialog = ref(false);
const addressLoading = ref(false);
const postcodeContainer = ref<HTMLDivElement | null>(null);
let daumScriptLoading: Promise<void> | null = null;

// 폼 데이터
const formData = ref({
  emp_code: '',
  m_sisul_code: '',
  emp_name: '',
  emp_birth: '',
  emp_birth_number: '',
  emp_job: '',
  emp_in_date: '',
  emp_out_date: '',
  emp_phone: '',
  emp_email: '',
  emp_addr: '',
  emp_addr_detail: ''
});

// 주민등록번호 입력 상태 (UI용)
const birthNumberFront = ref('');
const birthNumberBack = ref('');

// 생년월일에서 주민등록번호 앞자리 추출 (YYYYMMDD → YYMMDD)
const extractBirthFront = (birth: string): string => {
  if (!birth) return '';
  const digitsOnly = birth.replace(/[^\d]/g, '');
  if (digitsOnly.length === 8) {
    return digitsOnly.substring(2, 8);
  }
  return '';
};

// 생년월일에서 주민등록번호 앞자리 채우기
const fillBirthFrontFromBirth = () => {
  const front = extractBirthFront(formData.value.emp_birth);
  if (front) {
    birthNumberFront.value = front;
  }
};

// 옵션
const jobOptions = ['센터장', '사회복지사', '요양보호사', '간호사', '간호조무사', '물리치료사', '작업치료사', '기타'];

// computed
const dialogModel = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

const editingEmployee = computed(() => props.employee);

const isValidBirthDate = (value: string) => {
  if (!/^\d{8}$/.test(value)) return false;
  const year = parseInt(value.slice(0, 4), 10);
  const month = parseInt(value.slice(4, 6), 10);
  const day = parseInt(value.slice(6, 8), 10);
  if (month < 1 || month > 12) return false;
  if (day < 1 || day > 31) return false;
  const date = new Date(year, month - 1, day);
  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
};

const isBirthValid = computed(() => isValidBirthDate(formData.value.emp_birth));

const isFormValid = computed(() => {
  return !!(
    formData.value.emp_name &&
    formData.value.emp_birth &&
    isBirthValid.value &&
    formData.value.emp_job &&
    formData.value.emp_in_date
  );
});

// watch
watch(() => props.modelValue, (newVal) => {
  if (newVal) {
    birthNumberFront.value = '';
    birthNumberBack.value = '';
    if (props.employee) {
      // 수정 모드
      formData.value = { 
        ...props.employee, 
        emp_birth_number: '' 
      };
      // 생년월일에서 앞자리 추출
      birthNumberFront.value = extractBirthFront(props.employee.emp_birth);
    } else {
      // 신규 등록 모드
      formData.value = {
        emp_code: '',
        m_sisul_code: user.value?.m_sisul_code || '',
        emp_name: '',
        emp_birth: '',
        emp_birth_number: '',
        emp_job: '',
        emp_in_date: '',
        emp_out_date: '',
        emp_phone: '',
        emp_email: '',
        emp_addr: '',
        emp_addr_detail: ''
      };
    }
  }
});

// 메서드
const closeDialog = () => {
  emit('update:modelValue', false);
  birthNumberFront.value = '';
  birthNumberBack.value = '';
  formData.value = {
    emp_code: '',
    m_sisul_code: '',
    emp_name: '',
    emp_birth: '',
    emp_birth_number: '',
    emp_job: '',
    emp_in_date: '',
    emp_out_date: '',
    emp_phone: '',
    emp_email: '',
    emp_addr: '',
    emp_addr_detail: ''
  };
};

const saveEmployee = async () => {
  if (!isFormValid.value) return;
  
  isSaving.value = true;
  
  try {
    // 주민등록번호 조합: 앞자리 + 뒷자리
    const fullBirthNumber = (birthNumberFront.value && birthNumberBack.value) 
      ? (birthNumberFront.value + birthNumberBack.value) 
      : '';
    
    const response = await axios.post('/api/calc/employee', {
      ...formData.value,
      emp_birth_number: fullBirthNumber,
      m_sisul_code: user.value?.m_sisul_code
    }, {
      withCredentials: true
    });
    
    if (response.data.success) {
      // 수정 모드에서 입사일이 변경된 경우, leb_member_info 테이블도 업데이트
      if (editingEmployee.value && formData.value.emp_in_date !== props.employee?.emp_in_date) {
        try {
          await axios.post('/api/emp/update-start-date', {
            m_sisul_code: user.value?.m_sisul_code,
            emp_name: formData.value.emp_name,
            emp_birth: formData.value.emp_birth,
            emp_in_date: formData.value.emp_in_date
          }, {
            withCredentials: true
          });
        } catch (startDateError) {
          console.warn('급여 테이블 입사일 업데이트 실패:', startDateError);
        }
      }
      
      let message = editingEmployee.value ? '사원 정보가 수정되었습니다.' : '사원이 등록되었습니다.';
      
      // 신규 등록 시 생성된 사원코드 표시
      if (!editingEmployee.value && response.data.empCode) {
        message += ` (사원코드: ${response.data.empCode})`;
      }
      
      store.commit('showSnackbar', {
        text: message,
        color: 'success'
      });
      
      emit('saved');
      closeDialog();
    } else {
      store.commit('showSnackbar', {
        text: response.data.message || '저장에 실패했습니다.',
        color: 'error'
      });
    }
  } catch (error: any) {
    console.error('사원 저장 오류:', error);
    store.commit('showSnackbar', {
      text: error.response?.data?.message || '사원 저장 중 오류가 발생했습니다.',
      color: 'error'
    });
  } finally {
    isSaving.value = false;
  }
};

// 입력 포맷팅
const onNameInput = (e: Event) => {
  const target = e.target as HTMLInputElement;
  const value = target.value.replace(/[^가-힣]/g, '');
  formData.value.emp_name = value;
};

const onBirthInput = (e: Event) => {
  const target = e.target as HTMLInputElement;
  const value = target.value.replace(/[^\d]/g, '').slice(0, 8);
  formData.value.emp_birth = value;
};

const onPhoneInput = (e: Event) => {
  const target = e.target as HTMLInputElement;
  const digits = target.value.replace(/[^\d]/g, '').slice(0, 11);
  
  let formatted = digits;
  if (digits.length > 3 && digits.length <= 7) {
    formatted = `${digits.slice(0,3)}-${digits.slice(3)}`;
  } else if (digits.length > 7) {
    formatted = `${digits.slice(0,3)}-${digits.slice(3,7)}-${digits.slice(7)}`;
  }
  
  formData.value.emp_phone = formatted;
};

const onBirthNumberFrontInput = (e: Event) => {
  const target = e.target as HTMLInputElement;
  const value = target.value.replace(/[^\d]/g, '');
  birthNumberFront.value = value;
};

const onBirthNumberBackInput = (e: Event) => {
  const target = e.target as HTMLInputElement;
  const value = target.value.replace(/[^\d]/g, '');
  birthNumberBack.value = value;
};

// 주소 검색
const loadDaumPostcodeScript = async (): Promise<void> => {
  if ((window as any).daum?.Postcode) return;
  if (daumScriptLoading) {
    await daumScriptLoading;
    return;
  }
  daumScriptLoading = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Daum Postcode script load failed'));
    document.head.appendChild(script);
  });
  await daumScriptLoading;
};

const embedDaumPostcode = async () => {
  addressLoading.value = true;
  try {
    await loadDaumPostcodeScript();
    await nextTick();
    const container = postcodeContainer.value;
    if (!container) throw new Error('Container not ready');
    container.innerHTML = '';
    const Postcode = (window as any).daum?.Postcode;
    if (!Postcode) throw new Error('Daum Postcode is undefined');
    const postcode = new Postcode({
      oncomplete: (data: any) => {
        const road = data.roadAddress;
        const jibun = data.jibunAddress;
        const selected = road && road.length > 0 ? road : jibun;
        
        formData.value.emp_addr = selected || '';
        
        addressDialog.value = false;
        addressLoading.value = false;
      },
      onresize: (size: any) => {
        try {
          (container as HTMLDivElement).style.height = `${size.height}px`;
        } catch {}
      },
      width: '100%',
      height: '100%'
    });
    try {
      postcode.embed(container, { autoClose: true });
      addressLoading.value = false;
    } catch (e) {
      addressLoading.value = false;
      throw e;
    }
  } catch (e) {
    addressLoading.value = false;
    throw e;
  }
};

const openAddressModal = async () => {
  addressDialog.value = true;
};

watch(addressDialog, async (val) => {
  if (val) {
    try {
      await embedDaumPostcode();
    } catch (e) {
      addressDialog.value = false;
      store.commit('showSnackbar', {
        text: '주소 검색 로드에 실패했습니다.',
        color: 'error'
      });
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialogModel.value,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((dialogModel).value = $event)),
    "max-width": "700px",
    "content-class": "employee-dialog-wrapper"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "employee-card" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "employee-dialog-header" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                color: "white",
                class: "mr-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(editingEmployee.value ? 'mdi-account-edit' : 'mdi-account-plus'), 1)
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(editingEmployee.value ? '사원 정보 수정' : '신규 사원 등록'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "employee-dialog-content" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, {
                ref_key: "employeeForm",
                ref: employeeForm,
                modelValue: formValid.value,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formValid).value = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _cache[24] || (_cache[24] = _createElementVNode("h4", { class: "section-title" }, "기본 정보", -1)),
                    _createElementVNode("div", _hoisted_2, [
                      _cache[15] || (_cache[15] = _createElementVNode("label", { class: "compact-label" }, [
                        _createTextVNode(" 이름 "),
                        _createElementVNode("span", { class: "required-text" }, "* 필수입력")
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.emp_name) = $event)),
                        type: "text",
                        class: "compact-input",
                        placeholder: "이름을 입력하세요",
                        maxlength: "20",
                        onInput: onNameInput
                      }, null, 544), [
                        [_vModelText, formData.value.emp_name]
                      ]),
                      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "field-hint" }, "* 한글만 입력할 수 있습니다.", -1))
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _cache[17] || (_cache[17] = _createElementVNode("label", { class: "compact-label" }, [
                        _createTextVNode(" 생년월일 "),
                        _createElementVNode("span", { class: "required-text" }, "* 필수입력")
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.emp_birth) = $event)),
                        type: "text",
                        class: "compact-input",
                        placeholder: "YYYYMMDD (예: 19900101)",
                        maxlength: "8",
                        onInput: onBirthInput
                      }, null, 544), [
                        [_vModelText, formData.value.emp_birth]
                      ]),
                      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "field-hint" }, "* 8자리 숫자만 입력하세요. 예: 19950729", -1)),
                      (formData.value.emp_birth && !isBirthValid.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "유효한 생년월일을 입력하세요."))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _cache[22] || (_cache[22] = _createElementVNode("label", { class: "compact-label" }, "주민등록번호", -1)),
                      _createElementVNode("div", _hoisted_6, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((birthNumberFront).value = $event)),
                          type: "text",
                          class: "compact-input birth-front",
                          maxlength: "6",
                          placeholder: "앞자리 6자리",
                          onInput: onBirthNumberFrontInput
                        }, null, 544), [
                          [_vModelText, birthNumberFront.value]
                        ]),
                        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "birth-separator" }, "-", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((birthNumberBack).value = $event)),
                          type: "text",
                          class: "compact-input birth-back",
                          maxlength: "7",
                          placeholder: "뒷자리 7자리",
                          onInput: onBirthNumberBackInput
                        }, null, 544), [
                          [_vModelText, birthNumberBack.value]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _cache[21] || (_cache[21] = _createTextVNode(" * 선택 사항입니다. ", -1)),
                        (formData.value.emp_birth)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              size: "x-small",
                              variant: "text",
                              color: "#1e3a8a",
                              class: "ml-1",
                              onClick: fillBirthFrontFromBirth
                            }, {
                              default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                _createTextVNode(" 생년월일에서 앞자리 채우기 ", -1)
                              ]))]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _cache[23] || (_cache[23] = _createElementVNode("label", { class: "compact-label" }, [
                        _createTextVNode(" 직종 "),
                        _createElementVNode("span", { class: "required-text" }, "* 필수입력")
                      ], -1)),
                      _createVNode(_component_v_select, {
                        modelValue: formData.value.emp_job,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.emp_job) = $event)),
                        items: jobOptions,
                        variant: "outlined",
                        density: "compact",
                        placeholder: "직종을 선택하세요",
                        "hide-details": "",
                        "menu-props": { zIndex: 9999 }
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[27] || (_cache[27] = _createElementVNode("h4", { class: "section-title" }, "연락처 정보", -1)),
                    _createElementVNode("div", _hoisted_10, [
                      _cache[25] || (_cache[25] = _createElementVNode("label", { class: "compact-label" }, "휴대폰번호", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.emp_phone) = $event)),
                        type: "text",
                        class: "compact-input",
                        placeholder: "010-1234-5678",
                        maxlength: "13",
                        onInput: onPhoneInput
                      }, null, 544), [
                        [_vModelText, formData.value.emp_phone]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _cache[26] || (_cache[26] = _createElementVNode("label", { class: "compact-label" }, "이메일", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.emp_email) = $event)),
                        type: "email",
                        class: "compact-input",
                        placeholder: "이메일을 입력하세요",
                        maxlength: "50"
                      }, null, 512), [
                        [_vModelText, formData.value.emp_email]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[30] || (_cache[30] = _createElementVNode("h4", { class: "section-title" }, "주소 정보", -1)),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[28] || (_cache[28] = _createElementVNode("label", { class: "compact-label" }, "주소", -1)),
                      _createElementVNode("div", _hoisted_14, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.emp_addr) = $event)),
                          type: "text",
                          class: "compact-input",
                          placeholder: "주소 검색 버튼을 클릭하세요",
                          readonly: "",
                          onClick: openAddressModal
                        }, null, 512), [
                          [_vModelText, formData.value.emp_addr]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "address-search-btn",
                          onClick: openAddressModal
                        }, " 주소검색 ")
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[29] || (_cache[29] = _createElementVNode("label", { class: "compact-label" }, "상세주소", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.emp_addr_detail) = $event)),
                        type: "text",
                        class: "compact-input",
                        placeholder: "상세주소를 입력하세요",
                        maxlength: "50"
                      }, null, 512), [
                        [_vModelText, formData.value.emp_addr_detail]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _cache[33] || (_cache[33] = _createElementVNode("h4", { class: "section-title" }, "재직 정보", -1)),
                    _createElementVNode("div", _hoisted_17, [
                      _cache[31] || (_cache[31] = _createElementVNode("label", { class: "compact-label" }, [
                        _createTextVNode(" 입사일 "),
                        _createElementVNode("span", { class: "required-text" }, "* 필수입력")
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.emp_in_date) = $event)),
                        type: "date",
                        class: "compact-input"
                      }, null, 512), [
                        [_vModelText, formData.value.emp_in_date]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _cache[32] || (_cache[32] = _createElementVNode("label", { class: "compact-label" }, "퇴사일", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.emp_out_date) = $event)),
                        type: "date",
                        class: "compact-input"
                      }, null, 512), [
                        [_vModelText, formData.value.emp_out_date]
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "pa-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                onClick: closeDialog,
                disabled: isSaving.value
              }, {
                default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                  _createTextVNode(" 취소 ", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_v_btn, {
                color: "#1e3a8a",
                variant: "flat",
                onClick: saveEmployee,
                loading: isSaving.value,
                disabled: !isFormValid.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { class: "mr-1" }, {
                    default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                      _createTextVNode("mdi-content-save", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[36] || (_cache[36] = _createTextVNode(" 저장 ", -1))
                ]),
                _: 1
              }, 8, ["loading", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, {
        modelValue: addressDialog.value,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((addressDialog).value = $event)),
        "max-width": "560",
        "content-class": "address-dialog-wrapper"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            rounded: "lg",
            class: "address-card"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-bold" }, {
                default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                  _createTextVNode("주소 검색", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { style: {"height":"420px","position":"relative"} }, {
                default: _withCtx(() => [
                  (addressLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createVNode(_component_v_progress_circular, {
                          indeterminate: "",
                          color: "primary",
                          size: "48"
                        }),
                        _cache[38] || (_cache[38] = _createElementVNode("div", { class: "loading-text mt-3" }, "주소 검색을 불러오는 중...", -1))
                      ]))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("div", {
                    ref_key: "postcodeContainer",
                    ref: postcodeContainer,
                    style: {"width":"100%","height":"100%"}
                  }, null, 512), [
                    [_vShow, !addressLoading.value]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "justify-end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (addressDialog.value = false)),
                    disabled: addressLoading.value
                  }, {
                    default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                      _createTextVNode("닫기", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})